import { FunctionComponent } from 'react'

import { VideoAPIProps } from '@widgets/Video/types'
import { getTextWithExtraColon } from '@widgets/Video/utils'
import {
  Catchword,
  LiveLabel,
  TextWrapper,
  Title,
  Wrapper,
} from '@components/Video/VideoPlayer/VideoTitle'

export type VideoTitleProps = Pick<VideoAPIProps, 'title' | 'catchword'> & {
  isLiveStream?: boolean
}

const VideoTitle: FunctionComponent<VideoTitleProps> = ({
  title = '',
  catchword = '',
  isLiveStream,
}) => {
  return (
    <Wrapper>
      <TextWrapper>
        <Catchword>{getTextWithExtraColon(catchword)}</Catchword>
        <Title>{title}</Title>
        {isLiveStream && <LiveLabel>Live</LiveLabel>}
      </TextWrapper>
    </Wrapper>
  )
}

export default VideoTitle
